import type { CategoryBreakdown, CategoryResult, LendingCategory } from '@apply/lending-limits';
import { GuarantorSummaryRows } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/rows/GuarantorSummaryRows';
import { IGuarantorSummaryTableRow } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/interfaces/IGuarantorSummaryTableRow';

/**
 * Category → summary row label. `core` is shown as "Construction" here and as "Core" on
 * its own accordion; they are the same category.
 */
const ROW_LABEL: Record<LendingCategory, GuarantorSummaryRows> = {
    core: GuarantorSummaryRows.Construction,
    bridge: GuarantorSummaryRows.Bridge,
    loc: GuarantorSummaryRows.LOC,
    dscr: GuarantorSummaryRows.DSCR,
};

/** Row order, matching the mockup. */
const ROW_ORDER: LendingCategory[] = ['core', 'bridge', 'loc', 'dscr'];

const toRow = (category: CategoryResult): IGuarantorSummaryTableRow => ({
    summaryItemType: ROW_LABEL[category.category],
    bll: category.bll,
    outstandingAmount: category.outstanding,
    surplus: category.surplus,
    regBLLCapacity: category.regulatoryCapacity,
    maxSurplus: category.maxSurplus,
    total: category.total,
});

/**
 * Guarantor Summary grid rows.
 *
 * Each row's Outstanding matches its detail table's total row, so the summary and the
 * accordions below it reconcile by construction.
 */
export function toGuarantorSummaryRows(breakdown: CategoryBreakdown): IGuarantorSummaryTableRow[] {
    return ROW_ORDER.map((category) => toRow(breakdown.categories[category]));
}
